import React, { useEffect } from 'react';
import "@fontsource/poppins/400.css";
import "@fontsource/poppins/600.css";
import "@fontsource/poppins/700.css";
import './css/styles.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from "react-helmet-async";
import { ThemeProvider } from '@emotion/react';
import { Container, createTheme, CssBaseline } from '@mui/material';
import ListePrestations from './components/ListePrestations';
import ListeProduits from './components/ListeProduits';
import FicheProduit from './components/FicheProduit';
import Test from './components/Test';

const theme = createTheme({

	typography: {
		fontFamily: 'Poppins, "Helvetica Neue", Arial, sans-serif',
		product_price: {
			marginBottom: 20,
			align: 'center',
		},
		price: {
			fontWeight: 700,
			fontSize: 60,
		},
		price_mini_barre: {
			textDecoration: 'line-through',
			fontWeight: 600,
			fontSize: 25,
		},
		price_option: {
			fontWeight: 700,
			fontSize: 40,
		},
		currency: {
			fontSize: 25,
			fontWeight: 700,
			verticalAlign: "text-top",
			lineHeight: 2.3,
		},
		price_from: {
			marginTop: -20,
		},
		slot: {
			fontWeight: 600,
			fontSize: 30,
		},
		highlight: {
			fontWeight: 700,
			fontSize: 40,
		},
		highlight2: {
			fontWeight: 700,
			fontSize: 20,
		},
		highlight3: {
			color: '#555555',
			fontWeight: 700,
			fontSize: 26,
			lineHeight: 1.5,
		},
	}
});

function App() {

	useEffect(() => {
		console.log(process.env.REACT_APP_ENV);
	});

	return (
		<HelmetProvider>
			<div className="App">
				<ThemeProvider theme={theme}>
					<CssBaseline />
					<Container component="main" maxWidth={false}>
						<BrowserRouter>
							<Routes>
								<Route exact strict path={process.env.REACT_APP_CATALOGUE_URL + '/'} element={<ListePrestations />} />
								<Route exact strict path={process.env.REACT_APP_CATALOGUE_URL + '/:prestationKey/'} element={<ListeProduits />} />
								<Route exact strict path={process.env.REACT_APP_CATALOGUE_URL + '/:prestationKey/:produitKey/:finalize?/'} element={<FicheProduit />} />
								<Route exact strict path={'/zest/'} element={<Test />} />
							</Routes>
						</BrowserRouter>
					</Container>
				</ThemeProvider>
			</div>
		</HelmetProvider>
	);
}

export default App;